import type { BannerId, BannerSlot, SerpBannerConfig } from '../types';
import generateSlots from './generateSlots';

interface Params {
    config: SerpBannerConfig;
    anchor: number;
    step: number;
    totalCards: number;
    isEnabled: (id: BannerId) => boolean;
}

function calculateBannerSlots({ config, anchor, step, totalCards, isEnabled }: Params): BannerSlot[] {
    const fixed: BannerSlot[] = config.fixed
        .filter(({ id }) => isEnabled(id))
        .map(({ id, cardIndex }) => ({ cardIndex, bannerId: id } as const));

    const slots = generateSlots(anchor, step, totalCards);
    const queue = config.queue
        .filter((b) => isEnabled(b.id))
        .sort((a, b) => a.priority - b.priority);

    const dynamic: BannerSlot[] = [];
    let slotIndex = 0;

    for (const banner of queue) {
        if (slotIndex >= slots.length) break;
        const cardIndex = slots[slotIndex];
        if (banner.showIf && !banner.showIf(cardIndex)) continue;
        dynamic.push({ cardIndex, bannerId: banner.id } as const);
        slotIndex++;
    }

    const repeatQueue = queue.filter((b) => b.repeatMode !== 'once');
    let repeatIndex = 0;

    while (slotIndex < slots.length && repeatQueue.length > 0) {
        const banner = repeatQueue[repeatIndex % repeatQueue.length];
        dynamic.push({ cardIndex: slots[slotIndex], bannerId: banner.id } as const);
        slotIndex++;
        repeatIndex++;
    }
    
    return [...fixed, ...dynamic];
}

export default calculateBannerSlots;
